import config from 'config'
import { authHeader, router } from '../_helpers'

export const commentService = {
  postComment,
  getComments
}

function postComment (comment) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(comment)
  }

  return fetch(`${config.apiUrl}/test_comments`, requestOptions).then(handleResponse)
}

function getComments (testUuid) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/test_comments/${testUuid}`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    var data
    try {
      data = text && JSON.parse(text)
    } catch (e) {
      data = text
    }
    console.log('handleResponse commentS', text)

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        localStorage.removeItem('user_uuid')
        localStorage.removeItem('tokens')
        if (router.currentRoute.path !== '/login') {
          router.push('/login').catch(() => {})
        }
      }

      const error = {
        status: response.status || (data && data.status) || null,
        error: (data && data.message) || response.statusText
      }
      return Promise.reject(error)
    }

    return data
  })
}



// WEBPACK FOOTER //
// ./src/_services/comment.service.js